// Colgate University's majors (#2743). Read on 2026-10-01 from the official
// 2026-2027 University Catalog (catalog.colgate.edu, catoid=16): the Majors
// and Minors page's "Major" list, one group as the catalog gives it. The
// catalog's Undergraduate Program page heads its degree programs "Bachelor of
// Arts Degree (AB) Programs", so each major carries "AB" as written there.
// The trailing word "Major" is dropped from each name except the three
// topical majors, which need it ("Natural Sciences Topical Major in Marine -
// Freshwater Science" keeps it mid-name), and "English Major, Creative
// Writing Emphasis" reads "English, Creative Writing Emphasis"; the curly
// apostrophe in "Women's" is typed straight.
// Left out: minors, and the catalog's "Other" list (pre-professional studies
// and teacher certification, which are not majors). The KB's majors list was
// the starting point; the catalog wins.
const majors = {
    "slug": "colgate-university",
    "read": "2026-10-01",
    "intro": "Every major in Colgate's official 2026-2027 University Catalog, each leading to the Bachelor of Arts (AB). Minors, pre-professional studies and teacher certification are left out.",
    "groups": [
        {
            "name": "Colgate University",
            "source": {
                "label": "Colgate 2026-2027 University Catalog, Majors and Minors",
                "url": "https://catalog.colgate.edu/content.php?catoid=16&navoid=798"
            },
            "majors": [
                {
                    "name": "Africana and Latin American Studies",
                    "degree": "AB"
                },
                {
                    "name": "Anthropology",
                    "degree": "AB"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "AB"
                },
                {
                    "name": "Art History",
                    "degree": "AB"
                },
                {
                    "name": "Arts and Humanities Topical Major",
                    "degree": "AB"
                },
                {
                    "name": "Asian Studies",
                    "degree": "AB"
                },
                {
                    "name": "Astrogeophysics",
                    "degree": "AB"
                },
                {
                    "name": "Astronomy-Physics",
                    "degree": "AB"
                },
                {
                    "name": "Biochemistry",
                    "degree": "AB"
                },
                {
                    "name": "Biology",
                    "degree": "AB"
                },
                {
                    "name": "Chemistry",
                    "degree": "AB"
                },
                {
                    "name": "Chinese",
                    "degree": "AB"
                },
                {
                    "name": "Classical Studies",
                    "degree": "AB"
                },
                {
                    "name": "The Classics",
                    "degree": "AB"
                },
                {
                    "name": "Computer Science",
                    "degree": "AB"
                },
                {
                    "name": "Computer Science/Mathematics",
                    "degree": "AB"
                },
                {
                    "name": "Economics",
                    "degree": "AB"
                },
                {
                    "name": "Educational Studies",
                    "degree": "AB"
                },
                {
                    "name": "English",
                    "degree": "AB"
                },
                {
                    "name": "English, Creative Writing Emphasis",
                    "degree": "AB"
                },
                {
                    "name": "Environmental Biology",
                    "degree": "AB"
                },
                {
                    "name": "Environmental Economics",
                    "degree": "AB"
                },
                {
                    "name": "Environmental Geography",
                    "degree": "AB"
                },
                {
                    "name": "Environmental Geology",
                    "degree": "AB"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "AB"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "AB"
                },
                {
                    "name": "French",
                    "degree": "AB"
                },
                {
                    "name": "Geography",
                    "degree": "AB"
                },
                {
                    "name": "Geology",
                    "degree": "AB"
                },
                {
                    "name": "German",
                    "degree": "AB"
                },
                {
                    "name": "Greek",
                    "degree": "AB"
                },
                {
                    "name": "History",
                    "degree": "AB"
                },
                {
                    "name": "International Relations",
                    "degree": "AB"
                },
                {
                    "name": "Japanese",
                    "degree": "AB"
                },
                {
                    "name": "Latin",
                    "degree": "AB"
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "AB"
                },
                {
                    "name": "Mathematics",
                    "degree": "AB"
                },
                {
                    "name": "Middle Eastern and Islamic Studies",
                    "degree": "AB"
                },
                {
                    "name": "Molecular Biology",
                    "degree": "AB"
                },
                {
                    "name": "Music",
                    "degree": "AB"
                },
                {
                    "name": "Native American and Indigenous Studies",
                    "degree": "AB"
                },
                {
                    "name": "Natural Sciences Topical Major",
                    "degree": "AB"
                },
                {
                    "name": "Natural Sciences Topical Major in Marine - Freshwater Science",
                    "degree": "AB"
                },
                {
                    "name": "Neuroscience",
                    "degree": "AB"
                },
                {
                    "name": "Peace and Conflict Studies",
                    "degree": "AB"
                },
                {
                    "name": "Philosophy",
                    "degree": "AB"
                },
                {
                    "name": "Philosophy: Philosophy and Religion",
                    "degree": "AB"
                },
                {
                    "name": "Physical Science",
                    "degree": "AB"
                },
                {
                    "name": "Physics",
                    "degree": "AB"
                },
                {
                    "name": "Political Science",
                    "degree": "AB"
                },
                {
                    "name": "Psychological Science",
                    "degree": "AB"
                },
                {
                    "name": "Religion",
                    "degree": "AB"
                },
                {
                    "name": "Religion: Philosophy and Religion",
                    "degree": "AB"
                },
                {
                    "name": "Russian and Eurasian Studies",
                    "degree": "AB"
                },
                {
                    "name": "Social Science Topical Major",
                    "degree": "AB"
                },
                {
                    "name": "Sociology",
                    "degree": "AB"
                },
                {
                    "name": "Spanish",
                    "degree": "AB"
                },
                {
                    "name": "Studio Arts",
                    "degree": "AB"
                },
                {
                    "name": "Theater",
                    "degree": "AB"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "AB"
                }
            ]
        }
    ]
};

export default majors;
